document.addEventListener('DOMContentLoaded', function () {
  const PRODUCT_API = '/collections/all/products.json';
  const PRODUCT_LIMIT = 250;

  let products = [];
  let selectedProducts = [];
  let productsLoading = false;
  let productsLoaded = false;
  let vehicleData = [];
  let vehicleLoading = false;
  let vehicleLoaded = false;

  /* ========================================================
     PRODUCT DATA
     ======================================================== */

  async function loadProducts() {
    if (productsLoading || productsLoaded) return products;

    productsLoading = true;

    try {
      products = [];

      let page = 1;
      const seenIds = new Set();

      while (true) {
        const url = `${PRODUCT_API}?limit=${PRODUCT_LIMIT}&page=${page}`;

        const response = await fetch(url, {
          cache: 'no-store'
        });

        if (!response.ok) {
          throw new Error(
            `Unable to load Shopify products: ${response.status}`
          );
        }

        const data = await response.json();
        const pageProducts = Array.isArray(data.products)
          ? data.products
          : [];

        if (!pageProducts.length) {
          break;
        }

        let newProducts = 0;

        pageProducts.forEach(function (product) {
          if (!seenIds.has(product.id)) {
            seenIds.add(product.id);
            products.push(product);
            newProducts++;
          }
        });

        console.log(
          `[Installation Quote] Product page ${page}: ${pageProducts.length}, new: ${newProducts}`
        );

        /*
         * If Shopify ignores ?page= and returns
         * the same products, stop here.
         */
        if (newProducts === 0) {
          console.warn(
            '[Installation Quote] Same products returned. Stopping pagination.'
          );
          break;
        }

        /*
         * Last page.
         */
        if (pageProducts.length < PRODUCT_LIMIT) {
          break;
        }

        page++;

        /*
         * Safety limit.
         */
        if (page > 20) {
          console.warn(
            '[Installation Quote] Product pagination stopped at 20 pages.'
          );
          break;
        }
      }

      productsLoaded = true;

      console.log(
        '[Installation Quote] Total unique products loaded:',
        products.length
      );

    } catch (error) {
      console.error(
        '[Installation Quote] Product loading error:',
        error
      );
    } finally {
      productsLoading = false;
    }

    return products;
  }

  /* ========================================================
     PRODUCT BUILDER
     ======================================================== */

  function initInstallationProducts() {
    const textarea = document.querySelector(
      '.installation-quote-form textarea[name="0-1/products_accessories"]'
    );

    if (!textarea) return;

    const field = textarea.closest('.hsfc-TextareaField');

    if (!field) return;

    /*
     * HubSpot can re-render the field.
     * Only skip if our custom UI is still there.
     */
    if (
      field.querySelector(
        '.installation-product-builder'
      )
    ) {
      return;
    }

    textarea.style.display = 'none';

    const originalLabel =
      field.querySelector(
        '.hsfc-FieldLabel'
      );

    if (originalLabel) {
      originalLabel.style.display = 'none';
    }

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'installation-product-builder';

    /*
     * KEEP THE EXISTING PRODUCT UI
     */
    wrapper.innerHTML = `
      <div class="installation-product-search">
        <label class="installation-product-label">
          Products / Accessories <span>*</span>
        </label>

        <div class="installation-product-helper">
          Search and select the products you'd like installed.
          You can add multiple products.
        </div>

        <div class="installation-product-search-box">
          <input
            type="text"
            class="installation-product-search-input"
            placeholder="Search for a product..."
            autocomplete="off"
          >

          <span class="installation-product-search-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <circle
                cx="11"
                cy="11"
                r="7"
                stroke="currentColor"
                stroke-width="1.8"
              />

              <path
                d="M16.5 16.5L21 21"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
          </span>
        </div>

        <div class="installation-product-results"></div>
      </div>

      <div class="installation-selected-products"></div>
    `;

    field.appendChild(wrapper);

    const searchInput =
      wrapper.querySelector(
        '.installation-product-search-input'
      );

    const results =
      wrapper.querySelector(
        '.installation-product-results'
      );

    const selectedContainer =
      wrapper.querySelector(
        '.installation-selected-products'
      );

    /*
     * Load products only once.
     */
    loadProducts();

    /*
     * If products were already loaded before
     * HubSpot re-rendered the field, render immediately.
     */
    if (productsLoaded) {
      renderSelectedProducts();
    }

    /* ======================================================
       SEARCH
       ====================================================== */

    searchInput.addEventListener(
      'input',
      function () {
        const keyword =
          this.value
            .trim()
            .toLowerCase();

        if (!keyword) {
          results.innerHTML = '';
          results.classList.remove(
            'is-open'
          );
          return;
        }

        /*
         * Products may still be loading.
         */
        if (!productsLoaded) {
          results.innerHTML = `
            <div class="installation-product-no-results">
              Loading products...
            </div>
          `;

          results.classList.add(
            'is-open'
          );

          return;
        }

        const filteredProducts =
          products
            .filter(function (product) {
              const title =
                (product.title || '')
                  .toLowerCase();

              const sku =
                (product.variants || [])
                  .map(function (variant) {
                    return variant.sku || '';
                  })
                  .join(' ')
                  .toLowerCase();

              return (
                title.includes(keyword) ||
                sku.includes(keyword)
              );
            })
            .slice(0, 10);

        results.innerHTML = '';

        if (!filteredProducts.length) {
          results.innerHTML = `
            <div class="installation-product-no-results">
              No products found
            </div>
          `;

          results.classList.add(
            'is-open'
          );

          return;
        }

        filteredProducts.forEach(
          function (product) {
            const item =
              document.createElement(
                'button'
              );

            item.type = 'button';

            item.className =
              'installation-product-result';

            const skus =
              (product.variants || [])
                .map(function (variant) {
                  return variant.sku || '';
                })
                .filter(Boolean);

            const uniqueSkus =
              [...new Set(skus)];

            /*
             * KEEP SKU DISPLAY AS CURRENT UI
             */
            item.innerHTML = `
              <span class="installation-product-result-name">
                ${escapeHtml(product.title)}
              </span>

              ${
                uniqueSkus.length
                  ? `
                    <span class="installation-product-result-sku">
                      SKU: ${escapeHtml(
                        uniqueSkus.join(', ')
                      )}
                    </span>
                  `
                  : ''
              }
            `;

            item.addEventListener(
              'click',
              function () {
                addProduct(product);

                searchInput.value = '';

                searchInput.placeholder =
                  'Search another product...';

                results.innerHTML = '';

                results.classList.remove(
                  'is-open'
                );

                searchInput.focus();
              }
            );

            results.appendChild(item);
          }
        );

        results.classList.add(
          'is-open'
        );
      }
    );

    /* ======================================================
       ADD PRODUCT
       ====================================================== */

    function addProduct(product) {
      const existingProduct =
        selectedProducts.find(
          function (item) {
            return item.id === product.id;
          }
        );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        const variant =
          product.variants &&
          product.variants.length
            ? product.variants[0]
            : null;

        selectedProducts.push({
          id: product.id,

          product_name:
            product.title,

          quantity: 1,

          /*
           * Price is NOT shown.
           * Price is only stored for HubSpot.
           */
          price: variant
            ? parseFloat(variant.price)
            : 0,

          handle:
            product.handle,

          variant_id:
            variant
              ? variant.id
              : null
        });
      }

      renderSelectedProducts();
      updateHubSpotField();
    }

    /* ======================================================
       RENDER SELECTED PRODUCTS
       ====================================================== */

    function renderSelectedProducts() {
      selectedContainer.innerHTML = '';

      if (!selectedProducts.length) {
        return;
      }

      const title =
        document.createElement(
          'div'
        );

      title.className =
        'installation-selected-products-title';

      title.textContent =
        'SELECTED PRODUCTS (' +
        selectedProducts.length +
        ')';

      selectedContainer.appendChild(
        title
      );

      selectedProducts.forEach(
        function (product, index) {
          const item =
            document.createElement(
              'div'
            );

          item.className =
            'installation-selected-product';

          item.innerHTML = `
            <div class="installation-selected-product-info">
              <div class="installation-selected-product-name">
                ${escapeHtml(
                  product.product_name
                )}
              </div>
            </div>

            <div class="installation-selected-product-actions">

              <div class="installation-product-quantity">

                <button
                  type="button"
                  class="installation-quantity-minus"
                  data-index="${index}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <span class="installation-quantity-value">
                  ${product.quantity}
                </span>

                <button
                  type="button"
                  class="installation-quantity-plus"
                  data-index="${index}"
                  aria-label="Increase quantity"
                >
                  +
                </button>

              </div>

              <button
                type="button"
                class="installation-remove-product"
                data-index="${index}"
              >
                Remove
              </button>

            </div>
          `;

          selectedContainer.appendChild(
            item
          );
        }
      );

      attachProductActions();
    }

    /* ======================================================
       PRODUCT ACTIONS
       ====================================================== */

    function attachProductActions() {
      selectedContainer
        .querySelectorAll(
          '.installation-quantity-minus'
        )
        .forEach(
          function (button) {
            button.addEventListener(
              'click',
              function () {
                const index =
                  parseInt(
                    this.dataset.index,
                    10
                  );

                if (
                  selectedProducts[index]
                    .quantity > 1
                ) {
                  selectedProducts[index]
                    .quantity -= 1;
                } else {
                  selectedProducts.splice(
                    index,
                    1
                  );
                }

                renderSelectedProducts();
                updateHubSpotField();
                updateProductPlaceholder();
              }
            );
          }
        );

      selectedContainer
        .querySelectorAll(
          '.installation-quantity-plus'
        )
        .forEach(
          function (button) {
            button.addEventListener(
              'click',
              function () {
                const index =
                  parseInt(
                    this.dataset.index,
                    10
                  );

                selectedProducts[index]
                  .quantity += 1;

                renderSelectedProducts();
                updateHubSpotField();
              }
            );
          }
        );

      selectedContainer
        .querySelectorAll(
          '.installation-remove-product'
        )
        .forEach(
          function (button) {
            button.addEventListener(
              'click',
              function () {
                const index =
                  parseInt(
                    this.dataset.index,
                    10
                  );

                selectedProducts.splice(
                  index,
                  1
                );

                renderSelectedProducts();
                updateHubSpotField();
                updateProductPlaceholder();
              }
            );
          }
        );
    }

    function updateProductPlaceholder() {
      searchInput.placeholder =
        selectedProducts.length
          ? 'Search another product...'
          : 'Search for a product...';
    }

    /* ======================================================
       UPDATE HUBSPOT PRODUCT FIELD
       ====================================================== */

      function formatHubSpotProducts() {
        return selectedProducts
          .map(function (product) {
            const price = Number(product.price || 0)
              .toLocaleString('en-AU', {
                style: 'currency',
                currency: 'AUD'
              });

            return `${product.product_name} x ${product.quantity} — ${price}`;
          })
          .join('\n');
      }

    function updateHubSpotField() {
      const form = document.querySelector(
        '.installation-quote-form'
      );

      if (!form) {
        return;
      }

      // Always get the CURRENT HubSpot textarea
      const textarea = form.querySelector(
        'textarea[name="0-1/products_accessories"]'
      );

      if (!textarea) {
        console.warn(
          '[Installation Quote] Products textarea not found.'
        );
        return;
      }

      const productData = selectedProducts.map(function (product) {
        return {
          product_name: product.product_name,
          quantity: product.quantity,
          price: product.price,
          product_id: product.id,
          variant_id: product.variant_id,
          handle: product.handle
        };
      });

      const value = formatHubSpotProducts();

      const nativeSetter =
        Object.getOwnPropertyDescriptor(
          window.HTMLTextAreaElement.prototype,
          'value'
        );

      if (nativeSetter && nativeSetter.set) {
        nativeSetter.set.call(textarea, value);
      } else {
        textarea.value = value;
      }

      textarea.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      textarea.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      console.log(
        '[Installation Quote] Products:',
        productData
      );
    }



    /* ======================================================
       CLOSE SEARCH
       ====================================================== */

    document.addEventListener(
      'click',
      function (event) {
        if (
          !wrapper.contains(
            event.target
          )
        ) {
          results.classList.remove(
            'is-open'
          );
        }
      }
    );
  }


  /* ========================================================
   SYNC PRODUCTS BEFORE SUBMIT
   ======================================================== */

function syncProductsBeforeSubmit() {
  const form = document.querySelector(
    '.installation-quote-form'
  );

  if (!form) {
    console.warn(
      '[Installation Quote] HubSpot form not found before submit.'
    );
    return;
  }

  const textarea = form.querySelector(
    'textarea[name="0-1/products_accessories"]'
  );

  if (!textarea) {
    console.warn(
      '[Installation Quote] Products textarea not found before submit.'
    );
    return;
  }

  const productData = selectedProducts.map(function (product) {
    return {
      product_name: product.product_name,
      quantity: product.quantity,
      price: product.price,
      product_id: product.id,
      variant_id: product.variant_id,
      handle: product.handle
    };
  });

  const value = formatHubSpotProducts();

  const nativeSetter =
    Object.getOwnPropertyDescriptor(
      window.HTMLTextAreaElement.prototype,
      'value'
    );

  if (nativeSetter && nativeSetter.set) {
    nativeSetter.set.call(textarea, value);
  } else {
    textarea.value = value;
  }

  textarea.dispatchEvent(
    new Event('input', {
      bubbles: true
    })
  );

  textarea.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );

  console.log(
    '[Installation Quote] Final products before submit:',
    productData
  );
}


/* ========================================================
   HUBSPOT SUBMIT HANDLER
   ======================================================== */

function initHubSpotSubmitHandler() {
  const form = document.querySelector(
    '.installation-quote-form form'
  );

  if (!form) {
    return false;
  }

  if (
    form.dataset.installationSubmitWatcher === 'true'
  ) {
    return true;
  }

  form.dataset.installationSubmitWatcher = 'true';

  form.addEventListener(
    'submit',
    function () {
      console.log(
        '[Installation Quote] Submit detected.'
      );

      syncProductsBeforeSubmit();
    },
    true
  );

  console.log(
    '[Installation Quote] HubSpot submit handler initialized.'
  );

  return true;
}

  /* ========================================================
     VEHICLE CSV
     ======================================================== */

  async function loadVehicleData() {
    if (
      vehicleLoading ||
      vehicleLoaded
    ) {
      return vehicleData;
    }

    if (
      !window.VIKOR_VEHICLE_DB_URL
    ) {
      console.error(
        '[Installation Quote] VIKOR_VEHICLE_DB_URL is missing.'
      );

      return [];
    }

    vehicleLoading = true;

    try {
      const response =
        await fetch(
          window.VIKOR_VEHICLE_DB_URL,
          {
            cache: 'no-store'
          }
        );

      if (!response.ok) {
        throw new Error(
          `Vehicle CSV error: ${response.status}`
        );
      }

      const csvText =
        await response.text();

      vehicleData =
        parseVehicleCSV(
          csvText
        );

      vehicleLoaded = true;

      console.log(
        '[Installation Quote] Vehicle records:',
        vehicleData.length
      );

    } catch (error) {
      console.error(
        '[Installation Quote] Vehicle CSV loading error:',
        error
      );
    } finally {
      vehicleLoading = false;
    }

    return vehicleData;
  }

  /* ========================================================
     CSV PARSER
     ======================================================== */

  function parseVehicleCSV(
    csvText
  ) {
    const lines =
      csvText
        .split(/\r?\n/)
        .map(function (line) {
          return line.trim();
        })
        .filter(Boolean);

    const data = [];

    lines.forEach(
      function (line) {
        const columns =
          parseCSVLine(line);

        if (
          columns.length < 2
        ) {
          return;
        }

        const make =
          columns[0].trim();

        const model =
          columns[1].trim();

        const collection =
          columns[2]
            ? columns[2].trim()
            : '';

        /*
         * Skip header if present.
         */
        if (
          make.toLowerCase() ===
            'make' &&
          model.toLowerCase() ===
            'model'
        ) {
          return;
        }

        if (
          !make ||
          !model
        ) {
          return;
        }

        data.push({
          make: make,
          model: model,
          collection: collection
        });
      }
    );

    return data;
  }

  function parseCSVLine(
    line
  ) {
    const result = [];

    let value = '';
    let quoted = false;

    for (
      let i = 0;
      i < line.length;
      i++
    ) {
      const char =
        line[i];

      if (
        char === '"'
      ) {
        if (
          quoted &&
          line[i + 1] === '"'
        ) {
          value += '"';
          i++;
        } else {
          quoted =
            !quoted;
        }

        continue;
      }

      if (
        char === ',' &&
        !quoted
      ) {
        result.push(
          value.trim()
        );

        value = '';

        continue;
      }

      value += char;
    }

    result.push(
      value.trim()
    );

    return result;
  }

  /* ========================================================
     FIND VEHICLE FIELD
     ======================================================== */

  function findVehicleField(
    labelText,
    possibleNames
  ) {
    const form =
      document.querySelector(
        '.installation-quote-form'
      );

    if (!form) {
      return null;
    }

    for (
      const name of possibleNames
    ) {
      const field =
        form.querySelector(
          `[name="${name}"]`
        );

      if (field) {
        return field;
      }
    }

    const labels =
      form.querySelectorAll(
        'label, .hsfc-form-label, .hs-form-field label'
      );

    for (
      const label of labels
    ) {
      const text =
        label.textContent
          .trim()
          .toLowerCase();

      if (
        !text.includes(
          labelText
        )
      ) {
        continue;
      }

      const wrapper =
        label.closest(
          '.hsfc-form-field'
        ) ||
        label.closest(
          '.hs-form-field'
        ) ||
        label.parentElement;

      if (!wrapper) {
        continue;
      }

      const field =
        wrapper.querySelector(
          'input, select, button, [role="combobox"]'
        );

      if (field) {
        return field;
      }
    }

    return null;
  }

  /* ========================================================
     GET MAKE VALUE
     ======================================================== */

  function getMakeValue(
    field
  ) {
    if (!field) {
      return '';
    }

    if (
      field.matches(
        'input, select, textarea'
      )
    ) {
      return field.value.trim();
    }

    const ariaValue =
      field.getAttribute(
        'aria-label'
      );

    if (ariaValue) {
      return ariaValue.trim();
    }

    const dataValue =
      field.getAttribute(
        'data-value'
      );

    if (dataValue) {
      return dataValue.trim();
    }

    const selected =
      field.querySelector(
        '[aria-selected="true"], .selected'
      );

    if (selected) {
      return selected.textContent.trim();
    }

    return field.textContent.trim();
  }

  /* ========================================================
     CREATE MODEL SELECT
     ======================================================== */

  function createModelSelect(
    modelInput
  ) {
    if (!modelInput) {
      return null;
    }

    const existing =
      modelInput
        .parentElement
        .querySelector(
          '.installation-vehicle-model-select'
        );

    if (existing) {
      return existing;
    }

    const wrapper =
      modelInput.closest(
        '.hsfc-Field'
      ) ||
      modelInput.closest(
        '.hsfc-form-field'
      ) ||
      modelInput.closest(
        '.hs-form-field'
      ) ||
      modelInput.parentElement;

    if (!wrapper) {
      return null;
    }

    /*
     * Keep original HubSpot input.
     * Only hide it visually.
     */
    modelInput.style.display =
      'none';

    const select =
      document.createElement(
        'select'
      );

    select.className =
      'installation-vehicle-model-select';

    select.innerHTML =
      '<option value="">Select</option>';

    modelInput.parentNode.insertBefore(
      select,
      modelInput
    );

    select.addEventListener('change', function () {
      const value = this.value;

      // Update HubSpot/React controlled input correctly
      const nativeSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      );

      if (nativeSetter && nativeSetter.set) {
        nativeSetter.set.call(modelInput, value);
      } else {
        modelInput.value = value;
      }

      modelInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      modelInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      console.log(
        '[Installation Quote] Vehicle Model synced:',
        value
      );
    });

    return select;
  }

  /* ========================================================
     UPDATE MODEL
     ======================================================== */

  function updateModelOptions(
    makeValue,
    modelSelect,
    modelInput
  ) {
    if (!modelSelect) {
      return;
    }

    const make =
      String(
        makeValue || ''
      )
        .trim()
        .toLowerCase();

    modelSelect.innerHTML =
      '<option value="">Select</option>';

    modelSelect.disabled =
      true;

    if (modelInput) {
      modelInput.value = '';

      modelInput.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );
    }

    if (!make) {
      return;
    }

    const models =
      vehicleData
        .filter(
          function (vehicle) {
            return (
              vehicle.make
                .trim()
                .toLowerCase() ===
              make
            );
          }
        )
        .reduce(
          function (
            unique,
            vehicle
          ) {
            const exists =
              unique.some(
                function (item) {
                  return (
                    item.model
                      .trim()
                      .toLowerCase() ===
                    vehicle.model
                      .trim()
                      .toLowerCase()
                  );
                }
              );

            if (!exists) {
              unique.push(
                vehicle
              );
            }

            return unique;
          },
          []
        )
        .sort(
          function (a, b) {
            return a.model.localeCompare(
              b.model
            );
          }
        );

    models.forEach(
      function (vehicle) {
        const option =
          document.createElement(
            'option'
          );

        option.value =
          vehicle.model;

        option.textContent =
          vehicle.model;

        option.dataset.collection =
          vehicle.collection;

        modelSelect.appendChild(
          option
        );
      }
    );

    modelSelect.disabled =
      models.length === 0;
  }

  /* ========================================================
     INITIALIZE VEHICLE
     ======================================================== */

  function initVehicleSelector() {
    if (
      !vehicleLoaded ||
      !vehicleData.length
    ) {
      return false;
    }

    const form =
      document.querySelector(
        '.installation-quote-form'
      );

    if (!form) {
      return false;
    }

    const makeField =
      findVehicleField(
        'vehicle make',
        [
          'vehicle_make',
          '0-1/vehicle_make'
        ]
      );

    const modelInput =
      findVehicleField(
        'vehicle model',
        [
          'vehicle_model',
          '0-1/vehicle_model'
        ]
      );

    if (
      !makeField ||
      !modelInput
    ) {
      return false;
    }

    const modelSelect =
      createModelSelect(
        modelInput
      );

    if (!modelSelect) {
      return false;
    }

    /*
     * Avoid adding multiple listeners
     * to the same Make field.
     */
    if (
      makeField.dataset
        .vehicleModelWatcher ===
      'true'
    ) {
      return true;
    }

    makeField.dataset
      .vehicleModelWatcher =
      'true';

    modelSelect.disabled =
      true;

    let lastMake = '';

    function syncMake() {
      const make =
        getMakeValue(
          makeField
        );

      const normalized =
        make
          .trim()
          .toLowerCase();

      if (
        !normalized ||
        normalized === lastMake
      ) {
        return;
      }

      if (
        [
          'select',
          'search',
          'choose',
          'vehicle make'
        ].includes(
          normalized
        )
      ) {
        return;
      }

      lastMake =
        normalized;

      updateModelOptions(
        make,
        modelSelect,
        modelInput
      );
    }

    makeField.addEventListener(
      'change',
      syncMake
    );

    makeField.addEventListener(
      'input',
      syncMake
    );

    const makeObserver =
      new MutationObserver(
        syncMake
      );

    makeObserver.observe(
      makeField,
      {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      }
    );

    document.addEventListener(
      'click',
      function () {
        setTimeout(
          syncMake,
          50
        );
      }
    );

    /*
     * Check current Make immediately.
     */
    setTimeout(
      syncMake,
      100
    );

    console.log(
      '[Installation Quote] Vehicle selector initialized.'
    );

    return true;
  }

  /* ========================================================
     BOOT VEHICLE
     ======================================================== */

  async function bootVehicleSelector() {
    await loadVehicleData();

    if (
      !vehicleLoaded
    ) {
      return;
    }

    let attempts = 0;

    const timer =
      setInterval(
        function () {
          attempts++;

          initVehicleSelector();

          if (
            attempts >= 100
          ) {
            clearInterval(
              timer
            );
          }
        },
        300
      );
  }

  /* ========================================================
     HUBSPOT ASYNC FORM
     ======================================================== */

  const observer =
    new MutationObserver(
      function () {
        initInstallationProducts();
        initVehicleSelector();
        initHubSpotSubmitHandler();
      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  /* Initial boot */
  initInstallationProducts();
  bootVehicleSelector();
  initHubSpotSubmitHandler();

  /* ========================================================
     ESCAPE HTML
     ======================================================== */

  function escapeHtml(
    value
  ) {
    const div =
      document.createElement(
        'div'
      );

    div.textContent =
      value || '';

    return div.innerHTML;
  }
});